import _LANG_RTL from "./lang-rtl.json";
import _LANGS_FOR_COUNTRY_TEST from "./langs-for-country-test.json";

export const LANG_RTL = _LANG_RTL as string[];
export const LANGS_FOR_COUNTRY_TEST = _LANGS_FOR_COUNTRY_TEST as Record<string, string[]>;
